import React from 'react';

/**
 * Card - Composant conteneur pour afficher un contenu encadré avec ombre et padding.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenu à afficher dans la carte
 * @param {string} [props.className] - Classes CSS additionnelles
 * @param {Function} [props.onClick] - Fonction à appeler lors du clic sur la carte
 * @returns {JSX.Element}
 *
 * @example
 * <Card onClick={() => {}}>
 *   <h2>Titre</h2>
 *   <p>Contenu</p>
 * </Card>
 */

export default function Card({ children, className = '', onClick, ...props }) {
  return (
    <div 
      className={`w-full border border-blue-gray-100 rounded-lg p-6 shadow-sm bg-white/60 ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
} 